import Badge from '@mui/material/Badge';
import { translate } from 'react-multi-lang';
import { connect, useSelector } from 'react-redux';
import {
  Form,
  Image,
  Button,
} from 'react-bootstrap';
import React, { useEffect, useRef, useContext, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import SideBarMenu from './SidebarMenu';
import SearchInput from '../../Search/SearchInput';
import { Popper as ArrowPopper } from '../../Popper';
import { isNotVerified, isModel } from '../../../helpers/storage/user';
import CustomAutocomplete from '../../Input/CustomAutocomplete';
import useOnClickOutside from '../../../hooks/useOnClickOutside';
import { useViewWalletPopover } from '../../../hooks/context/viewWalletPopoverContext';
import { fetchWalletDetailsStart } from '../../../store/actions/WalletAction';
import { isAuthenticated } from '../../../helpers/authentication/authentication';
import { applyFilter, setSearchKey, setFilterValues } from '../../../store/actions/SearchAction';
import {
  fetchUserConfigurationsStart,
  searchUserCitiesStart,
  searchUserLocationsStart,
  searchUserStatesStart,
} from '../../../store/actions/UserConfigurationsAction';
import { fetchMessageAndNotificationCountStart } from '../../../store/actions/ChatAction';
import { fetchCurrentUserStart } from "../../../store/actions/BankAccountAction";
import F2FCallNotificationModal from '../../Modals/F2FCallNotificationModal';
import { SocketContext } from '../../../helpers/contexts/face2face';
import { getSiteLogo, getSiteName } from '../../../utils/brandingConfig';

import HomeIcon from '../../../images/icons/home.svg?react';
import ChatIcon from '../../../images/icons/chat.svg?react';
import LiveIcon from '../../../images/icons/Live_Icon.svg?react';
import Face2FaceIcon from '../../../images_new/icon/face2face.svg?react';
import VideoStoreIcon from '../../../images_new/icon/p_video.svg?react';
import NotificationIcon from '../../../images/icons/notification.svg?react';

import './style.css';
import '../../../main.css';
import '../../../dark.css';
import './styles/appheader.scss';
import PrimaryButton from '../../Buttons/PrimaryButton';

const performerWalletPopover = ({ spending, income, handleWallet }) => (
  <div className='pwp'>
    <div className='display-flex justify-content-between align-items-center'>
      <span className='pwp-title'>Spending Wallet</span>
      <span className='pwp-amount'>
        {`$ ${spending ? spending?.toLocaleString('en-US', { minimumFractionDigits: 2 }) : '0.00'}`}
      </span>
    </div>
    <hr />
    <div className='display-flex justify-content-between align-items-center'>
      <span className='pwp-title'>Income Wallet</span>
      <span className='pwp-amount'>
        {`$ ${income ? income?.toLocaleString('en-US', { minimumFractionDigits: 2 }) : '0.00'}`}
      </span>
    </div>
    <span role="button" className='pwp-view_walletBtn btn' onClick={handleWallet} aria-label='wallet'>
      View Wallet
    </span>
  </div>
);

const walletContent = ({ walletDetails, handleTogglePopOver }) => {
  function formatIncomeWalletAmount() {
    return walletDetails?.data?.user_wallet_income?.remaining
      ? walletDetails?.data?.user_wallet_income?.remaining?.toLocaleString('en-US', {
        minimumFractionDigits: 0,
      })
      : '$0.00';
  };

  function formatSpendingWalletAmount() {
    return walletDetails?.data?.user_wallet?.remaining
      ? walletDetails?.data?.user_wallet?.remaining?.toLocaleString('en-US', {
        minimumFractionDigits: 0,
      })
      : '$0.00';
  };

  return (
    <span role='button' className='performer-wallet-overlay mr-1' onClick={handleTogglePopOver} aria-label='wallet'>
      <div className='d-flex w-100 justify-content-around align-items-center income'>
        <Image src={'https://d9apl513jlx0u.cloudfront.net/public_assets/public/assets/images/icons/dollar-down.svg'} width='20' alt='dollor' />
        <p className='amount-text'>
          {formatIncomeWalletAmount()}
        </p>
      </div>
      <div className='d-flex w-100 justify-content-around align-items-center spending'>
        <Image src={'https://d9apl513jlx0u.cloudfront.net/public_assets/public/assets/images/icons/dollar-up.svg'} width='20' alt='dollor'/>
        <p className='amount-text'>
          {formatSpendingWalletAmount()}
        </p>
      </div>
    </span>
  );
};

const HeaderIndex = (props) => {
  const isDark = props.darkMode;
  const siteLogo = getSiteLogo({ isDark });
  const siteName = getSiteName();
  const { walletDetails } = props;
  const { setViewWalletPopoverStatus } = useViewWalletPopover();

  const navigate = useNavigate();
  const location = useLocation();
  const filterPopupRef = useRef();
  const [showPopOver, setShowPopOver] = React.useState(false);
  const [searchPopup, setSearchPopup] = useState(false);
  const [showSidebar, setShowSidebar] = useState(false);
  const [isCallNotificationModalOpen, setIsCallNotificationModalOpen] = useState(false);
  const {
    showCallNotification,
    setCallNotification
  } = useContext(SocketContext);
  const searchValues = useSelector((state) => state.search.filters.filterValues);
  const {
    genders: genderArray,
    body_types: bodyTypeArray,
    categories: categoryArray,
    ethnicities: ethnicityArray,
  } = useSelector((state) => state.userConfigurations.configurations.data);

  useOnClickOutside(filterPopupRef, () => setSearchPopup(false));

  const toggleCallNotification = () => {
    setCallNotification(false)
  }

  useEffect(() => {
    props.dispatch(fetchUserConfigurationsStart());
    if (isAuthenticated()) {
      props.dispatch(fetchWalletDetailsStart());
    }
  }, []);

  useEffect(() => {
    setShowSidebar(false);
    setShowPopOver(false);
    setViewWalletPopoverStatus(false);
    if (isAuthenticated()) {
      props.dispatch(fetchCurrentUserStart());
      props.dispatch(fetchMessageAndNotificationCountStart());
    }
  }, [location.pathname]);

  const handleTriggerCitySearch = (text, triggerSearch = true) => {
    const filterObj = {
      ...searchValues,
      city: text,
    };
    props.dispatch(setFilterValues(filterObj));
    if (text.length && triggerSearch)
      props.dispatch(
        searchUserCitiesStart({
          search_key: text,
        }),
      );
  };

  const handleCityChange = (val) => {
    const filterObj = {
      ...searchValues,
      city: val,
    };
    props.dispatch(setFilterValues(filterObj));
  };

  const handleTriggerStateSearch = (text, triggerSearch = true) => {
    const filterObj = {
      ...searchValues,
      state: text,
    };
    props.dispatch(setFilterValues(filterObj));
    if (text.length && triggerSearch)
      props.dispatch(
        searchUserStatesStart({
          search_key: text,
        }),
      );
  };

  const handleStateChange = (val) => {
    const filterObj = {
      ...searchValues,
      state: val,
    };
    props.dispatch(setFilterValues(filterObj));
  };

  const handleTriggerLocationSearch = (text, triggerSearch = true, selectedOption = null) => {
    const filterObj = {
      ...searchValues,
      location: text,
      location_city: selectedOption ? selectedOption.city : undefined,
      location_country: selectedOption ? selectedOption.country : undefined,
    };
    props.dispatch(setFilterValues(filterObj));
    if (text.length && triggerSearch)
      props.dispatch(
        searchUserLocationsStart({
          search_key: text,
        }),
      );
  };

  const handleLocationChange = (val, selectedOption) => {
    const filterObj = {
      ...searchValues,
      location: val,
      location_city: selectedOption ? selectedOption.city : undefined,
      location_country: selectedOption ? selectedOption.country : undefined,
    };
    props.dispatch(setFilterValues(filterObj));
  };

  const toggleSideBar = () => {
    if(!isAuthenticated()){
      navigate("/login")
    }else{
      setShowSidebar(!showSidebar);
    }
  };

  const handleRedirectToLogin = () => {
    navigate('/login');
  };

  const handleChangeSearch = (e) => {
    const key = e.target.name;
    const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    const filterObj = {
      ...searchValues,
      [key]: value,
    };
    props.dispatch(setFilterValues(filterObj));
  }

  const searchKey = useSelector((state) => state.search.filters.key);

  const handleSubmitSearch = (e) => {
    e.preventDefault();
    setSearchPopup(false);
    props.dispatch(applyFilter());
  }

  const resetSearch = () => {
    props.dispatch(setSearchKey(''));
    props.dispatch(
      setFilterValues({
        key: '',
        city: '',
        state: '',
        gender: '',
        height: '',
        category: '',
        body_type: '',
        location: '',
        location_city: undefined,
        location_country: undefined,
      }),
    );
  }

  const  isActivePath = (path) => {
    return location && path === location.pathname;
  }

  const handleWallet = () => {
    if (location.pathname === '/wallet') {
      setShowPopOver(false);
      setViewWalletPopoverStatus(true);
    } else {
      navigate('/wallet');
      setViewWalletPopoverStatus(true);
    }
  }

  return (
    <>
      <div className='app-header'>
        <div className='w-100 app-navbar'>
          <div className='app-header-left'>
            <img
              role={'button'}
              onClick={() => {
                props.dispatch(setSearchKey(''));
                navigate('/home');
              }}
              src={siteLogo}
              className='img-fluid mr-3'
              alt={siteName}
              id='stripper_logo'
              aria-label={`${siteName} logo`}
            />
            <div className='header-search'>
              <SearchInput
                id='search'
                placeholder='Search...'
                showFilterPopup={setSearchPopup}
                filterPopup={searchPopup}
                name='key'
                defaultValue={searchKey}
              />
            </div>
          </div>
          <div className='app-header-center'>
            <ul className='nav_list_top'>
              <Link
                to={'/'}
                id='home'
                aria-label='navigate to home'
                className={`m-0 p-0 app-nav-item ${isActivePath('/') ? 'm-current' : ''}`}
              >
                <HomeIcon
                  className={`nav-icon-header ${isActivePath('/') ? 'nav-icon-selected' : ''}`}
                />
              </Link>
              <Link
                to={'/notification'}
                aria-label='navigate to notification'
                id='notification'
                className={`m-0 p-0 app-nav-item ${isActivePath('/notification') ? 'm-current' : ''
                  }`}
              >
                <Badge badgeContent={props.bellCount} max={99} color='primary'>
                  <NotificationIcon
                    className={`nav-icon-header ${isActivePath('/notification') ? 'nav-icon-selected' : ''
                      }`}
                  />
                </Badge>
              </Link>
              <Link
                to={'/inbox'}
                aria-label='navigate to messages'
                className={`m-0 p-0 app-nav-item icon-with-round-hover ${location.pathname === '/inbox' ? 'm-current' : ''
                  }`}
              >
                <Badge badgeContent={props.unreadMessageCount} max={99} color='primary'>
                  <ChatIcon
                    className={`nav-icon-header ${isActivePath('/inbox') ? 'nav-icon-selected' : ''
                      }`}
                  />
                </Badge>
              </Link>
              <Link
                to={'/live'}
                aria-label='navigate to live'
                className={`m-0 p-0 app-nav-item icon-with-round-hover ${location.pathname === '/live' ? 'm-current' : ''
                  }`}
              >
                <LiveIcon
                  className={`nav-icon-header ${isActivePath('/live') ? 'nav-icon-selected' : ''}`}
                />
              </Link>
              <Link
                to={'/face2face'}
                aria-label='navigate to face2face'
                className={`m-0 p-0 app-nav-item icon-with-round-hover ${location.pathname === '/face2face' ? 'm-current' : ''
                  }`}
              >
                <Face2FaceIcon
                  className={`nav-icon-header ${isActivePath('/face2face') ? 'nav-icon-selected' : ''
                    }`}
                />
              </Link>
              <Link
                to={'/video-store'}
                aria-label='navigate to video store'
                className={`m-0 p-0 app-nav-item icon-with-round-hover ${location.pathname === '/video-store' ? 'm-current' : ''
                  }`}
              >
                <VideoStoreIcon
                  width={30}
                  height={30}
                  className={`nav-icon-header ${isActivePath('/video-store') ? 'nav-icon-selected' : ''
                    }`}
                />
              </Link>
              <button
                className='main-header-menu account res-show toggle_btn1'
                onClick={toggleSideBar}
                id='ham_burger'
                title='sideBar'
              >
                <Image
                  src={
                    'https://d9apl513jlx0u.cloudfront.net/public_assets/public/assets/images/icons/' +
                    (showSidebar === true
                      ? isDark === true
                        ? 'cross_black'
                        : 'burger'
                      : isDark === true
                        ? 'BurgerDark'
                        : 'burger_home') +
                    '.svg'
                  }
                  alt='cross icon'
                />
              </button>
            </ul>
          </div>
          <div className='app-header-right'>
            <div className='buttons d-flex align-items-center'>
              {isAuthenticated() && isModel() && (
                <Link
                  to={'/posts-create'}
                  aria-label='navigate to create post'
                  className={'main-header-menu btn btn-sm mr-2 post create_post_btn'}
                >
                  <Image
                    src={
                      'https://d9apl513jlx0u.cloudfront.net/public_assets/public/assets/images/icons/' +
                      (isDark === true ? 'create-post_white' : 'create-post') +
                      '.svg'
                    }

                    alt='create post icon'
                  />
                  Create Post
                </Link>
              )}
              {isAuthenticated() && !isModel() && (
                <Link
                  to={'/wallet'}
                  aria-label='navigate to wallet'
                  className='main-header-menu btn btn-sm mr-2 credit credit_btns'
                >
                  <div className='d-flex w-100 justify-content-around align-items-center'>
                    <Image src={'https://d9apl513jlx0u.cloudfront.net/public_assets/public/assets/images/icons/dollar.svg'} alt='dollar' />
                    <p className='amount-text pr-1'>
                      {walletDetails.loading
                        ? 'loading..'
                        : walletDetails?.data?.user_wallet?.remaining?.toLocaleString('en-US', {
                          minimumFractionDigits: 2,
                        })}
                    </p>
                  </div>
                </Link>
              )}
              {/* web */}
              {isModel() &&
                isAuthenticated() && (
                  <ArrowPopper
                    open={showPopOver}
                    placement="bottom"
                    onClose={() => {
                      setShowPopOver(false);
                      setViewWalletPopoverStatus(false);
                    }}
                    content={
                      performerWalletPopover({
                        spending: walletDetails?.data?.user_wallet?.remaining,
                        income: walletDetails?.data?.user_wallet_income?.remaining,
                        handleWallet
                      })
                    }
                  >
                    {walletContent({ walletDetails, handleTogglePopOver: () => setShowPopOver(!showPopOver) })}
                  </ArrowPopper>
                )}
              {isAuthenticated() ? <button
                id='sidebar-menu'
                onClick={toggleSideBar}
                disabled={!isAuthenticated()}
                className='main-header-menu account res-hide toggle_btn1'
                title='SideBar'
              >
                <Image
                  src={
                    'https://d9apl513jlx0u.cloudfront.net/public_assets/public/assets/images/icons/' +
                    (showSidebar === true
                      ? isDark === true
                        ? 'cross_black'
                        : 'burger'
                      : isDark === true
                        ? 'BurgerDark'
                        : 'burger_home') +
                    '.svg'
                  }
                  alt='cross icon'
                />
              </button> : 
              <PrimaryButton
                  variant='primary'
                  className='btn'
                  title='Sign In'
                  onClick={handleRedirectToLogin}
              />
              }
              <button
                id='sidebar-menu-closeBtn'
                onClick={toggleSideBar}
                disabled={!isAuthenticated()}
                className={
                  (showSidebar ? 'closeBtn ' : '') + 'main-header-menu account res-hide toggle_btn1'
                }
                title='sideBar'
              ></button>
            </div>
          </div>
        </div>
        <div className='res-header'>
          <ul className={`d-flex ${!isAuthenticated() ? "justify-content-center" : "justify-content-between"}  align-items-center box-shadow`}>
            <li>
              {isAuthenticated() ? 
              <button className='btn toggle_btn1' onClick={toggleSideBar} title="sidebar">
                <Image
                  src={                    
                    'https://d9apl513jlx0u.cloudfront.net/public_assets/public/assets/images/icons/' +
                    (isDark === true ? 'BurgerDark' : 'burger_home') +
                    '.svg'
                  }
                  alt = 'sideBarMenu'
                />
              </button> : 
              <PrimaryButton
                variant='primary'
                className='btn'
                title='Sign In'
                onClick={handleRedirectToLogin}
              />}
            </li>
            <li className='res-li m-0'>
              {isAuthenticated() && !isModel() && (
                <Link to={'/wallet'} className='btn credit d-flex' aria-label='navigate to wallet'>
                  <div className='d-flex w-100 justify-content-around align-items-center'>
                    <Image src={'https://d9apl513jlx0u.cloudfront.net/public_assets/public/assets/images/icons/res_doller.svg'} alt='doller' />
                    <p className='p-0 amount-text'>
                      {walletDetails?.data?.user_wallet?.remaining?.toLocaleString('en-US', {
                        minimumFractionDigits: 2,
                      })}
                    </p>
                  </div>
                </Link>
              )}
              {/* mobile */}
              {isModel() &&
                isAuthenticated() && (
                  <ArrowPopper
                    open={showPopOver}
                    placement="bottom"
                    onClose={() => {
                      setShowPopOver(false);
                      setViewWalletPopoverStatus(false);
                    }}
                    content={
                      performerWalletPopover({
                        spending: walletDetails?.data?.user_wallet?.remaining,
                        income: walletDetails?.data?.user_wallet_income?.remaining,
                        handleWallet
                      })
                    }
                  >
                    {walletContent({ walletDetails, handleTogglePopOver: () => setShowPopOver(!showPopOver) })}
                  </ArrowPopper>
                )}
            </li>
            <li>
              {showSidebar && (
                <button className='btn closeBtn m-0 p-0' onClick={toggleSideBar} title='sideBar'>
                  <Image
                    src={                      
                      'https://d9apl513jlx0u.cloudfront.net/public_assets/public/assets/images/icons/' +
                      (isDark === true ? 'cross_black' : 'burger') +
                      '.svg'
                    }
                    alt='cross'
                  />
                </button>
              )}
              {isAuthenticated() && isModel() && !showSidebar && (
                <Link to={'/posts-create'} onMouseDown={() => navigate('/posts-create')} className='btn' aria-label='navigate to create post' >
                  <Image
                    src={
                      'https://d9apl513jlx0u.cloudfront.net/public_assets/public/assets/images/icons/' +
                      (isDark === true ? 'plus_black' : 'plus_white') +
                      '.svg'
                    }
                    alt='plus'
                  />
                </Link>
              )}
            </li>
          </ul>
        </div>
      </div>
      {searchPopup ? (
        <div className='container-fluid filter-card'>
          <div
            className='search-dropdown-sec animate-slidedown filter-desktop d-none d-xl-block'
            style={{
              position: 'fixed',
              zIndex: 1,
              background: 'var(--background-color)',
            }}
            ref={filterPopupRef}
          >
            <div className='card list-unstyled search-dropdown-list-sec'>
              <div id='filter' className='card-header'>
                Filters
              </div>
              <Form onSubmit={handleSubmitSearch} translate='no'>
                <div className='card-body sec'>
                  <Form.Row className='row'>
                    <Form.Group className='col-md-4 col-sm-12' controlId='category'>
                      <Form.Label>Categories</Form.Label>
                      <Form.Control
                        as='select'
                        value={searchValues.category}
                        name='category'
                        onChange={handleChangeSearch}
                      >
                        <option value=''>Select</option>
                        {categoryArray.length > 0 &&
                          categoryArray.map((category, key) => {
                            return (
                              <option value={category.value} key={key}>
                                {category.label}
                              </option>
                            );
                          })}
                      </Form.Control>
                    </Form.Group>
                    <Form.Group className='col-md-4 col-sm-12' controlId='body_type'>
                      <Form.Label>Body Type</Form.Label>
                      <Form.Control
                        as='select'
                        value={searchValues.body_type}
                        name='body_type'
                        onChange={handleChangeSearch}
                      >
                        <option value=''>Select</option>
                        {bodyTypeArray.length > 0 &&
                          bodyTypeArray.map((type, key) => {
                            return (
                              <option value={type.value} key={key}>
                                {type.label}
                              </option>
                            );
                          })}
                      </Form.Control>
                    </Form.Group>
                    <Form.Group className='col-md-4 col-sm-12' controlId='gender'>
                      <Form.Label>Gender</Form.Label>
                      <Form.Control
                        as='select'
                        value={searchValues.gender}
                        name='gender'
                        onChange={handleChangeSearch}
                      >
                        <option value=''>Select</option>
                        {genderArray.length > 0 &&
                          genderArray.map((gender, key) => {
                            return (
                              <option value={gender.value} key={key}>
                                {gender.label}
                              </option>
                            );
                          })}
                      </Form.Control>
                    </Form.Group>
                  </Form.Row>
                  <Form.Row className='row'>
                    <Form.Group className='col-md-4 col-sm-12' controlId='ethnicity'>
                      <Form.Label>Ethnicity</Form.Label>
                      <Form.Control
                        as='select'
                        value={searchValues.ethnicity}
                        name='ethnicity'
                        onChange={handleChangeSearch}
                      >
                        <option value=''>Select</option>
                        {ethnicityArray.length > 0 &&
                          ethnicityArray.map((ethnicity, key) => {
                            return (
                              <option value={ethnicity.value} key={key}>
                                {ethnicity.label}
                              </option>
                            );
                          })}
                      </Form.Control>
                    </Form.Group> 
                    <Form.Group className='col-md-4 col-sm-12' controlId='height'>
                      <Form.Label>Height</Form.Label>
                      <Form.Control
                        placeholder='Height | 6.2ft'
                        name='height'
                        value={searchValues.height}
                        onChange={handleChangeSearch}
                      />
                    </Form.Group>
                    <Form.Group className='col-md-4 col-sm-12' controlId='zip_code'>
                      <Form.Label>Zip Code</Form.Label>
                      <Form.Control
                        placeholder='Zip Code'
                        name='zip_code'
                        value={searchValues.zip_code}
                        onChange={handleChangeSearch}
                      />
                    </Form.Group>
                    
                  </Form.Row>
                  <Form.Row className='row'>
                    <CustomAutocomplete
                      className='col-md-4 col-sm-12'
                      controlId='location'
                      label='Location'
                      placeholder='Location'
                      name='location'
                      value={searchValues.location}
                      handleOnChange={handleLocationChange}
                      handleSearch={handleTriggerLocationSearch}
                      options={props.locations.data}
                      getOptionLabel={(x) => `${x.city}, ${x.country}`}
                    />
                    <CustomAutocomplete
                      className='col-md-4 col-sm-12'
                      controlId='state'
                      label='State'
                      placeholder='State'
                      name='state'
                      value={searchValues.state}
                      handleOnChange={handleStateChange}
                      handleSearch={handleTriggerStateSearch}
                      options={props.states.data}
                      getOptionLabel={(x) => x.state}
                    />
                    <CustomAutocomplete
                      className='col-md-4 col-sm-12'
                      controlId='City'
                      label='City'
                      placeholder='City'
                      name='city'
                      value={searchValues.city}
                      handleOnChange={handleCityChange}
                      handleSearch={handleTriggerCitySearch}
                      options={props.cities.data}
                      getOptionLabel={(x) => x.city}
                    />
                   
                  </Form.Row>
                  <div className='pull-right pb-3'>
                    <Button
                      variant='default'
                      id='close'
                      type='button'
                      onClick={() => setSearchPopup(false)}
                    >
                      Close
                    </Button>{' '}
                    <Button
                      variant='outline-danger'
                      type='button'
                      id='reset'
                      onClick={() => resetSearch()}
                    >
                      Reset
                    </Button>{' '}
                    <Button id='search_submit' variant='danger' type='submit'>
                      Search
                    </Button>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </div>
      ) : null}
      <div className={`ham-sidebar ${showSidebar ? 'ham-sidebar-open' : ''}`}>
        <div className={`ham-sidebar-container ${showSidebar ? 'ham-sidebar-container-open' : ''}`}>
          <Link to={'/'} onMouseDown={() => navigate('/')} className='d-block d-xl-none desktopNone' aria-label="navigate to main page">
            <img
              src={siteLogo}
              className='img-fluid m-0 w100 mt-2'
              alt={siteName}
            />
          </Link>

          <SideBarMenu
            isNotVerified={isNotVerified}
            isModel={isModel}
            isDark={props.darkMode}
            designChange={props.designChange}
          />
        </div>
      </div>
      <F2FCallNotificationModal
        isOpen={showCallNotification}
        toggle={toggleCallNotification}
      />
    </>
  );
};

const mapStateToPros = (state) => ({
  profile: state.users.profile,
  walletDetails: state.wallet.walletData,
  bellCount: state.notification.bellCount,
  cities: state.userConfigurations.cities,
  states: state.userConfigurations.states,
  locations: state.userConfigurations.locations,
  notifications: state.notification.notifications,
  unreadMessageCount: state.chat.unreadMessageCount
});

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(mapStateToPros, mapDispatchToProps)(translate(HeaderIndex));
